module.exports = __webpack_public_path__ + "static/media/junor_maulana_a.f5563716.jpg";